import React from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css"; // your custom CSS
import { Responsive, WidthProvider } from "react-grid-layout";
import { useNavigate } from "react-router-dom";

// Import your logos
import adamsD from "../pictures/adamsDeed.png";
import adamsP from "../pictures/adamsP.png";
import berksD from "../pictures/berksD.png";
import berksP from "../pictures/berksP.png";
import cumberD from "../pictures/cumberD.png";
import cumberP from "../pictures/cumberP.png";
import dauphinD from "../pictures/DauphinD.png";
import dauphinP from "../pictures/DauphinP.png";
import juniataD from "../pictures/juniataD.png";
import juniataP from "../pictures/juniataP.png";
import lancasterD from "../pictures/lancasterD.png";
import lancasterP from "../pictures/lancasterP.png";
import lebanonD from "../pictures/lebanonD.png";
import lebanonP from "../pictures/lebanonP.png";
import mifflinD from "../pictures/mifflinD.png";
import mifflinP from "../pictures/mifflinP.png";
import northD from "../pictures/northD.png";
import northP from "../pictures/northP.png";
import perryD from "../pictures/perryD.png";
import perryP from "../pictures/perryP.png";
import schD from "../pictures/schD.png";
import schP from "../pictures/schP.png";
import yorkD from "../pictures/yorkD.png";
import yorkP from "../pictures/yorkP.png";
import snyderD from "../pictures/snyderD.png";
import snyderP from "../pictures/snyderP.png";

const ResponsiveGridLayout = WidthProvider(Responsive);

const widgets = [
  { key: "DauphinD", title: "Dauphin County Deed Search", url: "https://deeds.dauphincounty.gov/AcclaimWeb?_gl=1*dfzy27*_ga*MTc2MDg2NDQ1Ni4xNzU3Njk3NzI5*_ga_LRKYR0LF8E*czE3NTc2OTc3MjkkbzEkZzEkdDE3NTc2OTc5MzAkajU4JGwwJGgw", icon: dauphinD},
  { key: "DauphinP", title: "Dauphin County Parcel Viewer", url: "https://gis.dauphincounty.org/dauphincountyparcelviewer/", icon: dauphinP},
  { key: "LebanonD", title: "Lebanon County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: lebanonD},
  { key: "LebanonP", title: "Lebanon County Parcel Viewer", url: "https://lebcogis.maps.arcgis.com/apps/webappviewer/index.html?id=dc37fec2f8044fc3a7f2898ed5d602ac", icon: lebanonP},
  { key: "LancasterD", title: "Lancaster County Deed Search", url: "https://lancastercountypa-web.tylerhost.net/web/search/DOCSEARCH138S1", icon: lancasterD},
  { key: "LancasterP", title: "Pancaster County Parcel Viewer", url: "https://www.arcgis.com/apps/webappviewer/index.html?id=97a16dc9b3ae4648b0419a94a607f375", icon: lancasterP},
  { key: "AdamsD", title: "Adams County Deed Search", url: "https://landrecordspa.adamscountypa.gov/external/User/Login.aspx?ReturnUrl=%2fexternal%2fIndex.aspx", icon: adamsD},
  { key: "AdamsP", title: "Adams County Parcel Viewer", url: "https://mapping.adamscountypa.gov/apps/Public_Parcel_Viewer/", icon: adamsP},
  { key: "CumberlandD", title: "Cumberland County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: cumberD},
  { key: "CumberlandP", title: "Cumberland County Parcel Viewer", url: "https://gis.ccpa.net/propertymapper/", icon: cumberP},  
  { key: "YorkD", title: "York County Deed Search", url: "https://webrecorders.yorkcountypa.gov/web/", icon: yorkD},
  { key: "YorkP", title: "York County Parcel Viewer", url: "https://experience.arcgis.com/experience/b6d4d251171242ac8fdad88a20360b36", icon: yorkP},
  { key: "PerryD", title: "Perry County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: perryD},
  { key: "PerryP", title: "Perry County Parcel Viewer", url: "https://experience.arcgis.com/experience/cee3d225b6134d34a3031534a0026562/", icon: perryP},
  { key: "SnyderD", title: "Snyder County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: snyderD},
  { key: "SnyderP", title: "Snyder County Parcel Viewer", url: "https://www.snydercounty.org/community-resources/geographic-info-system-gis/", icon: snyderP},
  { key: "JuniataD", title: "Juniata County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: juniataD},
  { key: "JuniataP", title: "Juniata County Parcel Viewer", url: "https://juniata.civ.quest/#data_s=id%3AdataSource_3-197898f24dc-layer-7%3A82001", icon: juniataP},
  { key: "NorthumberlandD", title: "Northumberland County Deed Search", url: "https://www.landex.com/webstore/jsp/cart/DocumentSearch.jsp", icon: northD},
  { key: "NorthumberlandP", title: "Northumberland County Parcel Viewer", url: "https://gis.norrycopa.net/NorthViewer/", icon: northP},
  { key: "SchuylkillD", title: "Schuylkill County Deed Search", url: "https://i2m.uslandrecords.com/PA/Schuylkill/D/Default.aspx", icon: schD},
  { key: "SchuylkillP", title: "Schuylkill County Parcel Viewer", url: "https://services.co.schuylkill.pa.us/mapviewer/", icon: schP},
  { key: "BerksD", title: "Berks County Deed Search", url: "https://countyfusion4.govos.com/countyweb/loginDisplay.action?countyname=Berks", icon: berksD},
  { key: "BerksP", title: "Berks County Parcel Viewer", url: "https://gis.co.berks.pa.us/parcelviewer/", icon: berksP},
  { key: "MifflinD", title: "Mifflin County Deed Search", url: "https://pennsylvania.propertychecker.com/mifflin-county", icon: mifflinD},
  { key: "MifflinP", title: "Mifflin County Parcel Viewer", url: "https://gis.mifflincountypa.gov/portal/apps/webappviewer/index.html?id=b238d9c500284b428fd0d189a86547e0", icon: mifflinP},

];

// Layout config: x, y = position; w = width; h = height
const layout = [
  { i: "AdamsD", x: 0, y: 0, w: 1, h: 1 },
  { i: "AdamsP", x: 1, y: 0, w: 1, h: 1 },
  { i: "BerksD", x: 0, y: 1, w: 1, h: 1 },
  { i: "BerksP", x: 1, y: 1, w: 1, h: 1 },
  { i: "CumberlandD", x: 0, y: 2, w: 1, h: 1 },
  { i: "CumberlandP", x: 1, y: 2, w: 1, h: 1 },
  { i: "DauphinD", x: 0, y: 3, w: 1, h: 1 },
  { i: "DauphinP", x: 1, y: 3, w: 1, h: 1 },
  { i: "JuniataD", x: 0, y: 4, w: 1, h: 1 },
  { i: "JuniataP", x: 1, y: 4, w: 1, h: 1 },
  { i: "LancasterD", x: 0, y: 5, w: 1, h: 1 },
  { i: "LancasterP", x: 1, y: 5, w: 1, h: 1 },
  { i: "LebanonD", x: 0, y: 6, w: 1, h: 1 },
  { i: "LebanonP", x: 1, y: 6, w: 1, h: 1 },
  { i: "MifflinD", x: 0, y: 7, w: 1, h: 1 },
  { i: "MifflinP", x: 1, y: 7, w: 1, h: 1 },
  { i: "NorthumberlandD", x: 0, y: 8, w: 1, h: 1 },
  { i: "NorthumberlandP", x: 1, y: 8, w: 1, h: 1 },
  { i: "PerryD", x: 0, y: 9, w: 1, h: 1 },
  { i: "PerryP", x: 1, y: 9, w: 1, h: 1 },
  { i: "SchuylkillD", x: 0, y: 10, w: 1, h: 1 },
  { i: "SchuylkillP", x: 1, y: 10, w: 1, h: 1 },
  { i: "SnyderD", x: 0, y: 11, w: 1, h: 1 },
  { i: "SnyderP", x: 1, y: 11, w: 1, h: 1 },
  { i: "YorkD", x: 0, y: 12, w: 1, h: 1 },
  { i: "YorkP", x: 1, y: 12, w: 1, h: 1 },
];

export default function CountyDeed() {

  const navigate = useNavigate();

  // Define breakpoints and cols
  const breakpoints = { lg: 520, sm: 0 };
  const cols = { lg: 2, sm: 1 };

  // Layouts for each breakpoint
  const layouts = {
    lg: layout,
    sm: layout.map(item => ({ ...item, x: 0, w: 1 })), // stack vertically on small screens
  };

  const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      navigate(url);
    }
  };

  return (
    <div className="home-container-agent">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={150}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div
              key={widget.key}
              className="widget-card"
              onClick={() => handleClick(widget.url)}
            >
              <img src={widget.icon} alt={widget.title} className="widget-icon" />
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
    </div>
  );
}